import React, { useEffect } from 'react';
import './SocialMedia.css'; // Link to the CSS file for styling
import galleryData from '../static/js/gallery';

const Gallery = () => {
  // This useEffect will load the Instagram and Yelp embed scripts once the component mounts
  useEffect(() => {
    // Create Instagram embed script
    const instagramScript = document.createElement('script');
    instagramScript.src = 'https://www.instagram.com/embed.js';
    instagramScript.async = true;
    
    // Create Yelp embed script
    const yelpScript = document.createElement('script');
    yelpScript.src = 'https://www.yelp.com/embed/widgets.js';
    yelpScript.type = 'text/javascript';
    yelpScript.async = true;
    
    // Append the scripts to the document
    document.body.appendChild(instagramScript);
    document.body.appendChild(yelpScript);
    
    // Clean up function to remove the scripts when component unmounts
    return () => {
      // Check if scripts still exist before removing
      if (document.body.contains(instagramScript)) {
        document.body.removeChild(instagramScript);
      }
      if (document.body.contains(yelpScript)) {
        document.body.removeChild(yelpScript);
      }
    };
  }, []);

  return (
    <>
      <div className="gallery-page">
        <h1>Our Gallery</h1>
        <p>Explore our portfolio of projects to see the quality and craftsmanship we bring to every job.</p>
        
        <div className="social-media-section">
          {/* First Row: Instagram and Nextdoor side by side */}
          <div className="social-row">
            {/* Instagram Card */}
            <div className="social-media-card">
              <div className="social-media-content">
                <h2>Follow Us on Instagram</h2>
                <p>Check out our latest projects and updates. See behind-the-scenes content and get inspired by our electrical work across the Chicago area.</p>
              </div>
              <div className="social-media-embed instagram-embed">
                <blockquote 
                  className="instagram-media" 
                  data-instgrm-permalink="https://www.instagram.com/escuderoelectricalcontractors0/" 
                  data-instgrm-version="14"
                  style={{
                    background: '#FFF',
                    border: 0,
                    borderRadius: '15px',
                    boxShadow: '0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15)',
                    margin: '1px',
                    maxWidth: '300px',
                    minWidth: '220px',
                    padding: 0,
                    width: '100%'
                  }}>
                </blockquote>
              </div>
            </div>
          </div>
          
          {/* Second Row: Yelp Reviews spanning full width */}
          <div className="social-media-card yelp-card">
            <div className="social-media-content">
              <h2>Our Yelp Reviews</h2>
              <p>Read authentic reviews from our satisfied customers. See why Chicago area residents trust us for all their electrical needs.</p>
            </div>
            <div className="yelp-reviews-container">
              <span 
                className="yelp-review" 
                data-review-id="aiJv3Yfu0eqSLUt9TUcg7Q" 
                data-hostname="www.yelp.com"
              >
                Read <a href="https://www.yelp.com/user_details?userid=OCecpXhGGPZbvfs4qnk68A" rel="nofollow noopener">Lauren L.</a>'s <a href="https://www.yelp.com/biz/escudero-electrical-contractors-chicago?hrid=aiJv3Yfu0eqSLUt9TUcg7Q" rel="nofollow noopener">review</a> of <a href="https://www.yelp.com/biz/A9nDoZK06YvYZZG0VmAr2w" rel="nofollow noopener">Escudero Electrical Contractors</a> on <a href="https://www.yelp.com" rel="nofollow noopener">Yelp</a>
              </span>
              
              <span 
                className="yelp-review" 
                data-review-id="d61WtAstaFmnW3KjzTfXWg" 
                data-hostname="www.yelp.com"
              >
                Read <a href="https://www.yelp.com/user_details?userid=NBXko5inimHe1A8blhLo6A" rel="nofollow noopener">Arden J.</a>'s <a href="https://www.yelp.com/biz/escudero-electrical-contractors-chicago?hrid=d61WtAstaFmnW3KjzTfXWg" rel="nofollow noopener">review</a> of <a href="https://www.yelp.com/biz/A9nDoZK06YvYZZG0VmAr2w" rel="nofollow noopener">Escudero Electrical Contractors</a> on <a href="https://www.yelp.com" rel="nofollow noopener">Yelp</a>
              </span>
              
              <span 
                className="yelp-review" 
                data-review-id="8e_GeZGeW9DRlJtolggnbQ" 
                data-hostname="www.yelp.com"
              >
                Read <a href="https://www.yelp.com/user_details?userid=9O2XnvYVsApsaFjZuJgRIA" rel="nofollow noopener">Patrick G.</a>'s <a href="https://www.yelp.com/biz/escudero-electrical-contractors-chicago?hrid=8e_GeZGeW9DRlJtolggnbQ" rel="nofollow noopener">review</a> of <a href="https://www.yelp.com/biz/A9nDoZK06YvYZZG0VmAr2w" rel="nofollow noopener">Escudero Electrical Contractors</a> on <a href="https://www.yelp.com" rel="nofollow noopener">Yelp</a>
              </span>
            </div>
          </div>
        </div>

        {/* Gallery Section */}
        <div className="gallery-section">
          <h2>Project Gallery</h2>
          <div className="gallery-grid">
            {galleryData.map((gallery, index) => (
              <div className="gallery-item" key={index}>
                <img src={gallery.icon} alt={gallery.title} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Gallery;